<template>
  <div class="order-manage">
    <!-- <div class="container">
      <div class="condition">
        <el-form :inline="true">
          <el-form-item label="规格属性名称：">
            <el-input
              v-model.trim="searchval"
              placeholder="规格属性名称"
              clearable
              class="inp"
              @keyup.enter.native="search"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select v-model="value" clearable placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="inp"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="search-content">
          <el-button class="but el-but" @click="search">搜索</el-button>
          <el-button class="but" style="color: rgb(102, 102, 102)" @click="Reset">重置</el-button>
        </div>
      </div>
    </div> -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <div class="wrapper">
        <div class="crumbs">
          <eui-btn type="secondary" @click="addCategoryVisible = true"
            >申请规格属性</eui-btn
          >
          <div class="commodity-rigin">
            如平台商品的规格属性无法全面描述您的商品，请提交您的规格属性由平台运营人员新增
            <i class="el-icon-question"></i>
          </div>
        </div>
        <!-- <div class="form">
          <el-table :data="tableData" border style="width: 100%;">
            <el-table-column fixed label="序号" type="index" min-width="50">
              <template slot-scope="scope">
                <span>{{ (listQuery.pageNum - 1) * listQuery.pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="attributeName"
              label="规格名称"
              width="250"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="attributeValue"
              label="取值"
              width="250"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="attributeUnit"
              label="计量单位"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="categoryName"
              label="所属分类"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="attributeAuditStatus"
              :formatter="statusFormatter"
              label="审核状态"
              width="200"
              align="center"
            >
              <template #default="{row}">
                <span style="cursor: pointer;" v-if="row.attributeAuditStatus === 1">
                  审核中
                </span>
                <span style="cursor: pointer;" v-if="row.attributeAuditStatus === 2">
                  审核通过
                </span>
                <el-tooltip
                  v-if="row.attributeAuditStatus === 3"
                  class="item"
                  effect="dark"
                  :content="row.rejectReason"
                  placement="top-start"
                >
                  <span style="cursor: pointer; color: red;">
                    审核拒绝(拒绝原因)
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="申请时间"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="updateTime"
              label="审核时间"
              width="206"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center" width="150" fixed="right">
              <template #default="{row}">
                <el-button
                  type="primary"
                  @click="brandDel(row)"
                  v-if="row.attributeAuditStatus === 3"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div> -->
        <eTableList
          :table-data="tableData"
          :table-label="tableLabel"
          :index-show="true"
        >
          <template #attributeAuditStatus="{ scope }">
            <span
              v-if="scope.row.attributeAuditStatus === 1"
              style="cursor: pointer"
            >
              审核中
            </span>
            <span
              v-if="scope.row.attributeAuditStatus === 2"
              style="cursor: pointer"
            >
              审核通过
            </span>
            <el-tooltip
              v-if="scope.row.attributeAuditStatus === 3"
              class="item"
              effect="dark"
              :content="scope.row.rejectReason"
              placement="top-start"
            >
              <span style="cursor: pointer; color: red">
                审核拒绝(拒绝原因)
              </span>
            </el-tooltip>
          </template>
          <template #handle="{ scope }">
            <span
              v-if="scope.row.attributeAuditStatus === 3"
              class="table-handle-btn"
              @click="brandDel(scope.row)"
            >
              删除
            </span>
          </template>
        </eTableList>
        <div class="pagination">
          <el-pagination
            :current-page="listQuery.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!--新增-->
    <!-- <el-dialog
      title="规格属性申请"
      width="40%"
      :visible.sync="add"
      :before-close="handleClos"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属分类" prop="categoryId" filterable>
          <el-select
            v-model="ruleForm.categoryId"
            filterable
            placeholder="请输入分类名称"
            @change="Classification"
          >
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.categoryName"
              :value="item.categoryId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格名称" prop="attributeName">
          <el-input
            @input="attributeNameInput"
            v-model.trim="ruleForm.attributeName"
            class="inp"
          ></el-input>
        </el-form-item>
        <el-form-item label="规格值">
          <el-tag
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model.trim="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
            :minlength="1"
            :maxlength="20"
          ></el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+</el-button>
        </el-form-item>
        <el-form-item label="计量单位">
          <el-select v-model="ruleForm.unitName" placeholder="请输入计量单位">
            <el-option
              v-for="(item, index) in inquireList"
              :label="item.unitName"
              :key="index"
              :value="item.unitName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="handleClos">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->
    <eDialog
      dialog-title="规格属性申请"
      :center-dialog-visible="addCategoryVisible"
      popup-width="600px"
      destroy-close
      modal-append-to-body
      @resetPopupData="handleClos"
      @submitPopupData="submitForm('ruleForm')"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属分类" prop="categoryId" filterable>
          <el-select
            v-model="ruleForm.categoryId"
            filterable
            placeholder="请输入分类名称"
            @change="Classification"
          >
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.categoryName"
              :value="item.categoryId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格名称" prop="attributeName">
          <el-input
            v-model.trim="ruleForm.attributeName"
            class="inp"
            @input="attributeNameInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="规格值">
          <el-tag
            v-for="tag in dynamicTags"
            :key="tag"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            v-if="inputVisible"
            ref="saveTagInput"
            v-model.trim="inputValue"
            class="input-new-tag"
            size="small"
            :minlength="1"
            :maxlength="20"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+</el-button
          >
        </el-form-item>
        <el-form-item label="计量单位">
          <el-select v-model="ruleForm.unitName" placeholder="请输入计量单位">
            <el-option
              v-for="(item, index) in inquireList"
              :key="index"
              :label="item.unitName"
              :value="item.unitName"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button @click="handleClos">取消</el-button>
        </el-form-item> -->
      </el-form>
    </eDialog>
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import api from '../../api/product/index';
import utils from '../../utils/utils';
import eDialog from '../../components/common/e-dialog.vue';

export default {
  components: {
    eSearch,
    eTableList,
    eDialog,
  },
  data() {
    return {
      tableLabel: [
        {
          label: '规格名称',
          param: 'attributeName',
          align: 'center',
          minWidth: 140,
        },
        {
          label: '取值',
          param: 'attributeValue',
          align: 'center',
          minWidth: 140,
        },
        {
          label: '计量单位',
          param: 'attributeUnit',
          align: 'center',
          minWidth: 180,
        },
        {
          label: '所属分类',
          param: 'categoryName',
          align: 'center',
          minWidth: 110,
        },
        {
          label: '审核状态',
          param: 'attributeAuditStatus',
          align: 'center',
          slot: 'attributeAuditStatus',
          minWidth: 100,
        },
        {
          label: '申请时间',
          param: 'createTime',
          align: 'center',
          minWidth: 110,
        },
        {
          label: '审核时间',
          param: 'updateTime',
          align: 'center',
          minWidth: 110,
        },
        {
          label: '操作',
          align: 'center',
          fixed: 'right',
          width: '140',
          slot: 'handle',
          minWidth: 100,
        },
      ],

      fieldList: [
        {
          label: '规格属性',
          type: 'input',
          value: 'attributeName',
        },
        {
          label: '审核状态',
          type: 'select',
          value: 'attributeAuditStatus',
          list: 'attributeAuditStatusList',
        },
      ],

      listTypeInfo: {
        attributeAuditStatusList: [
          {
            name: '全部',
            id: '',
          },
          { name: '审核中', id: 1 },
          { name: '审核通过', id: 2 },
          { name: '审核拒绝', id: 3 },
        ],
      },

      listQuery: {
        pageNum: 1,
        pageSize: 10,
        attributeName: '',
        attributeAuditStatus: '',
      },
      cloneQuery: {},
      options: [
        {
          value: '1',
          label: '审核中',
        },
        {
          value: '2',
          label: '审核通过',
        },
        {
          value: '3',
          label: '审核拒绝',
        },
      ],
      value: '',
      add: false,
      addCategoryVisible: false,
      ruleForm: {
        attributeName: '',
        units: '',
        categoryId: '',
        unitName: '',
        attributeAuditStatus: 1,
      },
      categoryList: [],
      inquireList: [],
      num: 1,
      rules: {
        categoryId: [
          {
            required: true,
            message: '请选择分类名称',
            trigger: 'change',
          },
        ],
        attributeName: [
          {
            required: true,
            message: '请输入规格名称',
            trigger: 'change',
          },
          {
            min: 1,
            max: 20,
            message: '请输入长度1-20个字符',
            trigger: 'blur',
          },
        ],
        inputValu: [
          {
            required: true,
            message: '请输入规格值',
            trigger: 'change',
          },
        ],
      },
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      tableData: [],
      total: 0,
      searchval: '',
    };
  },
  created() {
    this.classify();
    this.cloneQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },
  methods: {
    brandDel(row) {
      this.$confirm('您确认要删除吗？不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { attributeAuditId = '' } = row;
          const { deleteAttributeAudit } = api;
          const result = await deleteAttributeAudit({ attributeAuditId });
          if (result.code === '200') {
            this.FormTheUser();
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    attributeNameInput() {
      this.ruleForm.attributeName = utils.deleteSpace(
        this.ruleForm.attributeName
      );
    },
    // 格式化
    statusFormatter(row) {
      let name = '';
      this.options.forEach((item) => {
        if (item.value == row.attributeAuditStatus) {
          console.log(item.label);
          name = item.label;
        }
      });
      return name;
    },
    // 获取所有分类
    async classify() {
      const res = await api.selectLeafCategoryList();
      if (res.code == 200) {
        console.log(res, '改掉的新的数据277');
        this.categoryList = res.data;
        this.FormTheUser();
      }
    },
    // 获取当前分类下的计量单位
    Classification() {
      api
        .getUnitByCategory({
          categoryId: this.ruleForm.categoryId,
        })
        .then((res) => {
          this.inquireList = res.data;
        });
      this.ruleForm.unitName = '';
    },
    // 表单预验证(调用提交函数)
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubmitAudit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 提交
    SubmitAudit() {
      let categoryName = '';
      // 循环当前分类数组进行对比
      this.categoryList.map((item) => {
        if (this.ruleForm.categoryId == item.categoryId) {
          categoryName = item.categoryName;
        }
      });
      const params = {
        attributeAuditStatus: this.ruleForm.attributeAuditStatus,
        attributeName: this.ruleForm.attributeName,
        attributeUnit: this.ruleForm.unitName,
        attributeValueList: this.dynamicTags,
        categoryName,
        categoryId: this.ruleForm.categoryId,
      };
      console.log(params, '新增了一个 categoryId');
      // this.tableData.unshift(params)
      api.createAttributeAudit(params).then((res) => {
        if (res.code === '200') {
          console.log(res, '新增了一个 categoryId');
          this.ruleForm.categoryName = '';
          this.ruleForm.attributeName = '';
          this.dynamicTags = [];
          this.ruleForm.unitName = '';
          this.addCategoryVisible = false;
          this.FormTheUser();
          this.$refs.ruleForm.resetFields();
          this.$message({
            showClose: true,
            message: '提交成功',
            type: 'success',
          });
        }
      });
    },
    handleClos() {
      this.addCategoryVisible = false;
      this.ruleForm.categoryId = '';
      this.dynamicTags = [];
      this.ruleForm.attributeName = '';
      this.ruleForm.unitName = '';
      this.$refs.ruleForm.resetFields();
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((item) => {
        console.log(item);
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      const inputValue = utils.deleteSpace(this.inputValue);
      const flag = this.dynamicTags.some((item) => item === inputValue);
      if (flag) {
        this.$message({
          showClose: true,
          message: '规格值不能重复',
          type: 'warning',
        });
      }
      if (inputValue && !flag) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    async FormTheUser() {
      const res = await api.queryAttributeAuditPage(this.listQuery);
      if (res.code == 200) {
        console.log(res, '改掉的新的数据377');
        this.tableData = res.data.records;
        this.total = res.data.total;
        console.log(this.tableData);
      }
    },
    // 分页
    handleSizeChange(pageSize) {
      console.log(pageSize);
      this.listQuery.pageSize = pageSize;
      this.FormTheUser();
    },
    handleCurrentChange(pageval) {
      console.log(pageval);
      this.listQuery.pageNum = pageval;
      this.FormTheUser();
    },
    getList(params) {
      /* this.listQuery = {
        attributeName: this.searchval,
        attributeAuditStatus: this.value,
        pageNum: 1,
        pageSize: this.listQuery.pageSize,
      }; */
      api.queryAttributeAuditPage(params).then((res) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    // 搜索
    handleFilter(val) {
      this.listQuery = { ...val };
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleReset() {
      this.listQuery = { ...this.cloneQuery };
      this.getList(this.cloneQuery);
      this.FormTheUser();
      this.classify();
    },
    // 重置
    Reset() {
      this.searchval = '';
      this.value = '';
      this.FormTheUser();
      this.classify();
      this.listQuery = { pageNum: 1, pageSize: 10 };
    },
  },
};
</script>
<style>
.el-tooltip__popper {
  width: 320px;
}
</style>

<style scoped lang="scss">
.order-manage {
  .condition {
    .line {
      display: flex;
      justify-content: center;

      .reset {
        color: #333;
        border: 1px solid #c5c5c5;
        margin-right: 30px;
      }
    }

    .price {
      display: flex;

      ::v-deep .el-input {
        width: 116px;
      }
    }

    ::v-deep .el-input {
      width: 260px;
    }

    .price-range {
      display: flex;

      ::v-deep .el-input__inner {
        width: 70%;
      }
    }
  }

  .but {
    width: 80px;
    height: 30px;
    text-align: center;
  }

  .crumbs {
    position: relative;
  }

  .commodity {
    width: 112px;
    height: 30px;
    border: 1px solid hsl(0, 1%, 40%);
    background: #d6d1d1;
    text-align: center;
    line-height: 30px;
    font-size: 13px;
    color: #fff;
  }

  .commodity-rigin {
    position: absolute;
    right: 0;
    top: 5px;
    font-size: 13px;
    color: #666666;
  }

  .inp {
    width: 50%;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 0;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 0;
    vertical-align: bottom;
  }

  .el-tag--small {
    height: 30px;
    line-height: 30px;
  }

  .el-button-shen {
    width: 104px;
    height: 30px;
    box-sizing: border-box;
  }

  .el-but {
    border: 1px solid #2587ff;
    color: #2587ff;
  }

  ::v-deep.el-table thead {
    color: #000;
  }

  .block {
    text-align: right;
    padding-top: 10px;
  }
  .search-content {
    display: flex;
    justify-content: center;
    ::v-deep .el-button {
      min-width: 80px;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      color: #333;
      & + .el-button {
        margin-left: 30px;
        color: #fff;
      }
    }
  }
}
</style>
